export const capitalize = (s: string) =>
  s.toLowerCase().replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
